import { NeoReport, Report } from "@singularsystems/neo-reporting";
import BankTransferLetterCapitalCriteria from "./BankTransferLetterCapitalCriteria";

@NeoReport("BankTransferLetterCapital", { hidden: true })
export default class BankTransferLetterCapitalReport extends Report<BankTransferLetterCapitalCriteria> {

    constructor() {
        super(BankTransferLetterCapitalCriteria);
    }

    public renderCriteria() {
        return <div>
        </div>;
    }
}